import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProductShowcase } from './components/ProductShowcase';
import { Footer } from './components/Footer';
import { BackgroundDecor } from './components/BackgroundDecor';
import { LanguageProvider } from './contexts/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="3f8eydhsi3pt5">
      <div className="relative min-h-screen w-full overflow-hidden bg-[#F7F4EE] font-body antialiased" data-id="element-1" data-mp="2rkno0jqitmui">
        <BackgroundDecor data-id="element-2" data-mp="2mm2nej7cx15j" />

        <div className="relative" data-id="element-3" data-mp="2mmvjmq8ow89f">
          <Header data-id="element-4" data-mp="2mjpvpebsrcfa" />
          <main data-id="element-5" data-mp="31aqd48uiugnk">
            <Hero data-id="element-6" data-mp="31b8ka0iq2fa9" />
            <ProductShowcase data-id="element-7" data-mp="31bs1ff0jszn8" />
          </main>
          <Footer data-id="element-8" data-mp="31cjn9y4cfj0b" />
        </div>
      </div>
    </LanguageProvider>;
}